module.exports = __webpack_public_path__ + "static/media/icon-menu-list.76f2e8c4.svg";